import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import InternalSidebar from '../../components/InternalSidebar';
import InternalTopMenu from '../../components/InternalTopMenu';
import EmailVerificationBanner from '../../components/EmailVerificationBanner';

const PixUpdate = () => {
  const { logout } = useAuth();
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [pixKey, setPixKey] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!uuid) {
      setError('Chave PIX não encontrada.');
      setLoading(false);
      return;
    }

    const fetchDetail = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/bank/pix/detail/${uuid}`);
        setPixKey(response.data?.pixKey || '');
      } catch (err) {
        setError(
          err.response?.data?.message ||
            err.message ||
            'Não foi possível carregar a chave PIX.'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [uuid]);

  const isValid = pixKey.trim().length > 0;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isValid || submitting || !uuid) return;

    try {
      setSubmitting(true);
      setError('');
      setSuccess('');

      await api.post(`/bank/pix/update/${uuid}`, {
        pixKey: pixKey.trim(),
      });

      setSuccess('Chave PIX atualizada com sucesso.');
      setTimeout(() => navigate('/bank/pix'), 1200);
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Não foi possível atualizar a chave PIX.';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <div className="min-h-screen bg-[#f7f7f7] text-slate-700">
      <div className="min-h-screen flex flex-col lg:flex-row">
        <div className="lg:hidden">
          <div className="flex items-center justify-between px-6 py-4 bg-white shadow-sm">
            <button
              type="button"
              className="text-2xl text-slate-700"
              onClick={toggleSidebar}
              aria-label="Abrir menu"
            >
              <i className="bi-list"></i>
            </button>
            <img src="/img/branded/logob.png" alt="Stackfy" className="h-8" />
            <div className="w-7" />
          </div>
        </div>

        <InternalSidebar active="account-section" open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {sidebarOpen && (
          <button
            type="button"
            className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
            aria-label="Fechar menu"
          ></button>
        )}

        <main className="flex-1 px-6 py-8 lg:px-10 lg:py-12">
          <EmailVerificationBanner />
          <header className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <button
              type="button"
              onClick={() => navigate('/account')}
              className="text-sm font-semibold flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
            >
              <i className="bi-arrow-left-short text-xl"></i> Voltar
            </button>

            <InternalTopMenu onLogout={logout} />
          </header>

          <section className="max-w-xl">
            <div className="rounded-3xl border border-slate-200 bg-white px-6 py-8 shadow-sm">
              <h1 className="text-xl font-semibold text-slate-900 mb-6">Atualizar chave PIX</h1>

              {loading ? (
                <div className="text-sm text-gray-500">Carregando dados...</div>
              ) : (
                <>
                  {error && (
                    <div className="mb-4 rounded border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">{error}</div>
                  )}
                  {success && (
                    <div className="mb-4 rounded border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
                      {success}
                    </div>
                  )}

                  <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
                    <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3">
                      <i className="bi-key text-slate-400 text-lg"></i>
                      <input
                        type="text"
                        value={pixKey}
                        onChange={(e) => setPixKey(e.target.value)}
                        placeholder="Chave PIX"
                        className="w-full bg-transparent text-sm outline-none placeholder:text-slate-400"
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={!isValid || submitting}
                      className={`mt-4 inline-flex items-center justify-center rounded-full px-6 py-2 text-sm font-semibold transition-colors ${
                        !isValid || submitting
                          ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                          : 'bg-tBlue text-white hover:bg-tBlue2'
                      }`}
                    >
                      {submitting ? 'Atualizando...' : 'Atualizar'}
                    </button>
                  </form>
                </>
              )}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default PixUpdate;

